<template lang="pug">
  div
    .tile.is-ancestor(v-for="row in list")
      .tile.is-parent.is-4(v-for="item in row", :key="item.id")
        .tile.is-child.card
          //.card-header
            p.card-header-title {{item.name}}
          .card-content
            .content
              p.title.is-4(:data-testid="'app-title-' + item.id") {{item.name}}
              p {{item.desc}}
          .card-footer
            router-link.button.is-main-link.is-medium(
              :to="{name: applicationPaths[item.id], query: {target}}",
              :data-testid="'app-link-' + item.id"
            )
              span.has-text-weight-bold PDFを作成する
              b-icon(icon="chevron-circle-right")
</template>

<script>
import Util from '@/utils/util'

export default {
  name: 'BaseAppSelection',
  props: {
    target: {type: String, required: false, default: 'e'} // p: partner, e: enduser
  },
  data () {
    return {
      list: [],
      applicationPaths: {
        license: 'BuyLicenseAndSupport',
        service: 'ServiceRequest',
        // switch: 'NeoMigration',
        addition: 'LicenseAddition',
        subtraction: 'LicenseSubtraction',
        userdata: 'ChangeCustomerInfo'
      }
    }
  },
  created () {
    // applicationTypesを3列ずつに分割する
    const applicationTypes = require('@/data/application-types')
    let list = []
    let rowCount = -1
    let count = 0
    for (let item in applicationTypes) {
      if (!Util.isIncludes(applicationTypes[item].target, this.target)) {
        continue
      }
      if (count % 3 === 0) {
        rowCount++
        list[rowCount] = []
      }
      list[rowCount].push(applicationTypes[item])
      count++
    }
    this.list = list
  }
}
</script>

<style scoped>
.tile.card {
  padding-bottom: 4em !important; /* 申請書へ進むボタンの分空ける */
}
.card-footer {
  padding: 1em;
  border: none;
  display: block;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.card-footer .button {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseAppSelection.vue